import Header from './components/Header';
import Hero from './components/Hero';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import Process from './components/Process';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import ServiceAreas from './components/ServiceAreas';
import FAQ from './components/FAQ';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';
import FloatingCallButton from './components/FloatingCallButton';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <WhyChoose />
        <Process />
        <Gallery />
        <Testimonials />
        <ServiceAreas />
        <FAQ />
        <LeadForm />
      </main>
      <Footer />
      <FloatingCallButton />
    </div>
  );
}